import React from 'react';

const CategoryCard = ({ category,onView, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden group border border-gray-100">
      {/* Image */}
      <div className="relative h-52 overflow-hidden bg-gray-100">
        <img
          src={category.image}
          alt={category.category}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <span className="absolute bottom-3 left-3 bg-green-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
          Category
        </span>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-base font-bold text-gray-800 truncate">{category.category}</h3>

        {category.description && (
          <p className="text-sm text-gray-500 mt-1 line-clamp-1">{category.description}</p>
        )}

        {/* Key Points */}
        {/* {category.keyPoints?.length > 0 && (
          <ul className="mt-3 space-y-1">
            {category.keyPoints.slice(0, 3).map((point, i) => (
              <li key={i} className="flex items-center gap-2 text-xs text-gray-600">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 flex-shrink-0" />
                {point}
              </li>
            ))}
            {category.keyPoints.length > 3 && (
              <li className="text-xs text-green-600 font-medium pl-3.5">
                +{category.keyPoints.length - 3} more
              </li>
            )}
          </ul>
        )} */}

        {/* Actions */}
        <div className="flex gap-2 mt-4 pt-8 border-t border-gray-100">
            <button
            onClick={onView}
            className="flex-1 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-medium transition"
          >
            👁️ View
          </button>
          <button
            onClick={onEdit}
            className="flex-1 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 text-sm font-medium transition"
          >
            ✏️ Edit
          </button>
          <button
            onClick={onDelete}
            className="flex-1 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 text-sm font-medium transition"
          >
            🗑️ Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;